var gql = require("graphql-tag");

const HOUSE_ONE = gql`
    query HouseOne($id: Int!) {
        housesOne(id: $id) {
            id
            region_id
            district_id
            street_id
            full
            house
        }
    }
`;

module.exports = HOUSE_ONE;
